const pages = {
  id: 'pages',
  type: 'group',
  children: [
    {
      id: 'menu-websites',
      title: 'Websites',
      type: 'item',
      url: '/websites'
    },
    {
      id: 'menu-revenue',
      title: 'Revenue',
      type: 'item',
      url: '/revenue'
    },
    {
      id: 'menu-settings',
      title: 'Settings',
      type: 'item',
      url: '/settings'
    },
    {
      id: 'menu-help',
      title: 'Help & Support',
      type: 'item',
      url: '/support'
    }
  ]
}

export default pages
